import React, { useContext } from "react";
import { render as generatePlainText } from "datocms-structured-text-to-plain-text";

import { Headline } from "../../components/Headline";
import { Tagline } from "../../components/Tagline/Tagline";
import { SectionContainer } from "../../components/SectionContainer";
import { StructuredTextRenderer } from "../../components/StructuredTextRenderer";

import { generateClassString as gcs } from "../../lib/helper/generateClassString";
import { createStructuredData } from "../../lib/helper/createStructuredData";

import Accordion from "../../components/Accordion";

import * as styles from "./component.module.less";
import GeneralPageContext from "../../templates/GeneralPageContext";

function Faq({
    data: { anker, background, tagline, semanticOfHeadline, headline, faq },
    type
}) {
    const {
        layout: { showAnchorNavigation }
    } = useContext(GeneralPageContext);

    const structuredDataEntries = faq.map((faqEntry) => ({
        "@type": "Question",
        name: faqEntry.question,
        acceptedAnswer: {
            "@type": "Answer",
            text: faqEntry.answer?.value
                ? generatePlainText(faqEntry.answer)
                : ""
        }
    }));

    return (
        <>
            {createStructuredData("FAQPage", {
                id: "#",
                mainEntity: structuredDataEntries
            })}

            <SectionContainer
                sectionId={anker}
                containerClass={gcs(styles.faqContainer, [
                    showAnchorNavigation,
                    styles.anchored
                ])}
                background={background}
            >
                <header>
                    <Tagline>{tagline}</Tagline>
                    <Headline semanticOfHeadline={semanticOfHeadline}>
                        {headline}
                    </Headline>
                </header>

                <Accordion>
                    {faq.map((f, i) => {
                        return (
                            <Accordion.Item
                                key={`faq-element-${i}`}
                                eventKey={i.toString()}
                            >
                                <Accordion.Button>
                                    {f.question}
                                </Accordion.Button>

                                <Accordion.Body>
                                    <StructuredTextRenderer
                                        data={f.answer}
                                        noContainer
                                        contentElementType={type}
                                    />
                                </Accordion.Body>
                            </Accordion.Item>
                        );
                    })}
                </Accordion>
            </SectionContainer>
        </>
    );
}

export { Faq };
